import React from 'react';
import { Dialog } from 'primereact/dialog';
import { useHistory, useLocation } from 'react-router-dom';
import * as qs from 'query-string';
import { defineMessages, useIntl } from 'react-intl';
import { RespondentType } from '../../../shared/Constants';
import { Button } from 'primereact/button';
import useNewBusinessModelAccountCheck from '../../../hooks/useNewBusinessModelAccountCheck';

const messages = defineMessages({
  notice: {
    id: 'super-link-notice.notice',
    defaultMessage: 'Notice',
  },
  firstParagraph: {
    id: 'super-link-notice.first-paragraph',
    defaultMessage:
      'If the maximum number of Internal Respondents (employees) included in your NoLimit subscription is reached while SuperLink is active, it will automatically disable.',
  },
  secondParagraph: {
    id: 'super-link-notice.second-paragraph',
    defaultMessage:
      'However, your NoLimit subscription also includes an unlmited number of External Respondents (candidates). Thus, you can avoid automatic disablement by choosing this Respondent Type instead. Alternatively, you can',
  },
  thirdParagraph: {
    id: 'super-link-notice.third-paragraph',
    defaultMessage:
      'Release Internal Respondents by changing some of your existing Internal Respondents to External Respondents, or by deleting some of your Internal Respondents.',
  },
  fourthParagraph: {
    id: 'super-link-notice.fourth-paragraph',
    defaultMessage: 'Upgrade your NoLimit subscription to include more Internal Respondents.',
  },
  gotIt: {
    id: 'user-notification-dialog.button',
    defaultMessage: 'Got it',
  },
});

const SuperLinkNotice = () => {
  const history = useHistory();
  const { pathname, search } = useLocation();
  const { formatMessage } = useIntl();
  const { type } = qs.parse(search);

  const hideDialog = () => history.push(pathname);
  const { isNewBusinessModelAccount } = useNewBusinessModelAccountCheck();
  const dialogVisible = isNewBusinessModelAccount && type === RespondentType.INTERNAL;

  return (
    <Dialog visible={dialogVisible} header={formatMessage(messages.notice)} onHide={hideDialog}>
      <h4>{formatMessage(messages.firstParagraph)}</h4>
      <p>{formatMessage(messages.secondParagraph)}</p>
      <ul>
        <li>{formatMessage(messages.thirdParagraph)}</li>
        <li>{formatMessage(messages.fourthParagraph)}</li>
      </ul>
      <div className="flex-center">
        <Button type="button" className="p-button-primary" onClick={hideDialog} label={formatMessage(messages.gotIt)} />
      </div>
    </Dialog>
  );
};

export default SuperLinkNotice;
